

import Vue, { unref } from 'vue';
import { Component, Model, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex/types/helpers';
import {  FormFields } from  '@/models/repsol-template.model';
import { namespace } from 'vuex-class';
import { ImportLabels } from '@/models/repsol-template-aggregate.model';
import { FileData } from '@/models/file-entities.model';
import ComponentBase from '@/mixins/componentBase';
import { tUi } from '@/utils/translate';

@Component({
    name: 'RepsolImportComponent',
    components: {

      }
})

export class RepsolImportComponent extends ComponentBase {


    public inputKey: any;
    // respuestaImportacion: ImportResult;
    // respuestaImportacionCalendario: ImportResultCalendario;

    isOpen = false;
    mostrarRespuesta = false;

    @Prop()
    url: string;

    @Prop()
    headerText: string;

    @Prop()
    configuracion:ImportLabels[];

    // @Prop()
    // model: any;

    // @Prop()
    // isValid: boolean;

    // @Prop()
    // onlyRead: boolean;
    modeloRespuesta:any;

    @Prop()
    popupWidth: string;

    @Prop()
    changeVisibility!: boolean;
    @Watch('changeVisibility')
    changeStatus(val: boolean): void {
        this.isOpen = val;
        this.mostrarRespuesta = false;
    }

    
  created(): void {
    this.inputKey = 1;
  }

    mostrarPropiedad(propiedad:ImportLabels):boolean{
      if(!propiedad.ocultarCeroVacio)
      {
          return true;
      }

      if(propiedad.table){
        return this.modeloRespuesta[propiedad.campo] && this.modeloRespuesta[propiedad.campo].length > 0;
      }

      return this.modeloRespuesta[propiedad.campo];
    }

    propiedadCols(propiedad:ImportLabels):number{
      return propiedad.table ? 12 : 6;
    }

    eventAction(action:string): void{
        this.$emit("eventAction", action);
    }

    translate(value: string, params?: Record<string, unknown>): string {
      return tUi(value, params);
    }

    get translatedHeaderText(): string {
      const text = String(this.headerText || '').replace(/^>+\s*/, '').trim();
      return this.translate(text);
    }

    getTableItems(propiedad: ImportLabels): any[] {
      const rows = this.modeloRespuesta?.[propiedad.campo];

      if (!propiedad.table || !Array.isArray(rows)) {
        return [];
      }

      const columns = (propiedad.table as Array<{ value: string }>).map((header) => header.value);

      return rows.map((row: any) => {
        if (!row || typeof row !== 'object') {
          return row;
        }

        const translatedRow = { ...row };
        columns.forEach((column: string) => {
          if (column === 'tipo' && typeof translatedRow[column] === 'string') {
            translatedRow[column] = this.translate(translatedRow[column]);
          }
        });

        return translatedRow;
      });
    }

    cargarArchivo(file: File) {
      this.openSpinner("operaciones.cargandoExcel");
      this.getBase64(file).then((res) => {
         this.post({ apiUrl: this.url, entity: res }).then(r =>{
           this.modeloRespuesta = r;
           this.mostrarRespuesta = true;
           this.clearFileSelected();
           this.closeSpinner();
         }).catch(() =>{
          this.mostrarKO("operaciones.errorCargarExcel");
          this.closeSpinner();
          this.clearFileSelected();
         });

        // this.$emit("fileSelected", res);
      });
    }

    // formattedErrorMessagesOperaciones() {
    //   return this.respuestaImportacion.operacionesMensajeError;
    // }

    // formattedErrorMessagesCalendario() {
    //   return this.respuestaImportacionCalendario.diasMensajeError;
    // }

    public async nuevoDocumento(): Promise<void> {
      // this.respuestaImportacion = {
      //   operacionesTotalExcel: 28,
      //   operacionesCreados: 20,
      //   operacionesActualizados: 5,
      //   operacionesErroneos: 3,
      //   operacionesMensajeError: [ { row: 3, message: "La cantidad debe ser superior a 0" },
      //       { row: 7, message: "El código del producto no existe" },
      //       { row: 12, message: "El mercado se encuentra cerrado el día 25/12/2023" }]
      // }
      this.mostrarRespuesta = true;
    }

  public async nuevoCalendario(): Promise<void> {

    // this.respuestaImportacionCalendario = {
    //   diasProcesados: 12,
    //   diasCierre: 7,
    //   earlyClose: 3,
    //   diasErroneos: 2,
    //   diasMensajeError: [ { row: 3, message: "Formato de día no reconocido" },
    //       { row: 7, message: "Formato de hora no reconocido" }]
    // }
    this.mostrarRespuesta = true;
  }

    public mounted() {
        const popupMain = document.getElementById("popup-main");
        if(popupMain != null) {
            popupMain.style.maxWidth = this.popupWidth == undefined ? "800" : this.popupWidth + "px";
        }
    }

    public clearFileSelected(): void {
      this.inputKey++;
      this.$forceUpdate();
    }

    getBase64(file: File): Promise<FileData> {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let content: any;
        reader.readAsDataURL(file);
        reader.onload = function () {
          content = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve({
            nombre: file.name,
            data: content.split(',')[1],
          } as FileData);
        };
      });
    }
}

export default RepsolImportComponent;

Vue.component('repsol-import', RepsolImportComponent);
